import IntroDeals from '@screens/intro/deals'
import Page from '@shell/Page'
import { router } from 'expo-router'

export default function DealsPage() {
  const handleBack = () => {
    if (router.canGoBack()) {
      router.back()
    } else {
      router.replace('/')
    }
  }

  return (
    <Page stage="deals" intro back={handleBack}>
      <IntroDeals />
    </Page>
  )
}
